'use client';

import React from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { TypographyH2, TypographyP } from '@/components/ui/typography';
import SectionBase from '@/components/ui/sections/section-base';
import { FORM_SECTION_ID } from '../consts';

export const SECTION_ID = 'working-together';

export default function WorkingTogetherSection() {
  return (
    <SectionBase id={SECTION_ID} background="bg-background">
      <TypographyH2>How We Will Work Together</TypographyH2>
      <TypographyP>
        When you request a consultation, Craig, our experienced home builder,
        will reach out to you within 24 business hours to coordinate a meeting
        time that suits your schedule.
      </TypographyP>

      <TypographyP>
        Rest assured, punctuality is our priority. We&apos;ll be there at the
        appointed time, ready to discuss your project, whether it&apos;s at
        your property, our office, or through online video conferencing.
      </TypographyP>

      <TypographyP>
        A consultation isn&apos;t just about discussing plans-it&apos;s a
        chance for us to get to know each other and ensure we&apos;re the
        perfect match for your project.
      </TypographyP>

      <TypographyH2 className="mt-5">
        What to bring to your consultation:
      </TypographyH2>

      <ul className="my-6 ml-6 list-disc [&>li]:mt-2">
        <li>Questions about our services and expertise</li>

        <li>
          Inquiries about the design, renovation, or construction process
        </li>

        <li>Your wish list and project requirements</li>

        <li>Any design inspirations or sketches you have</li>
      </ul>

      <Button className="w-full md:w-fit" asChild>
        <Link href={`#SECTION-${FORM_SECTION_ID}`}>
          Request Your Consultation Now
        </Link>
      </Button>
    </SectionBase>
  );
}
